export default __webpack_public_path__ + "static/media/AcademicBG.2da11022.jpg";